<template>
  <div class="pvtprediction-dashboard" :class="{ 'dark-mode': isDarkMode }">
    <EmbeddedBreadcrumbBar :items="breadcrumbItems" />
    <div v-if="error" class="error-message">
      {{ error }}
    </div>
    <iframe
      v-else
      :src="iframeSrc"
      class="prediction-iframe"
      ref="predictionIframe"
      @load="handleIframeLoad"
    ></iframe>
  </div>
  <div v-if="isLoading" class="loader-container-eda">
    <div class="loader">
      <div class="spinner"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EmbeddedBreadcrumbBar from "@/components/layout/Common/EmbeddedBreadcrumbBar.vue";
import { notifyIframeDarkMode, getIframeOrigin } from "@/utils/iframeDarkMode";

export default {
  name: "PVTPrediction",
  components: {
    EmbeddedBreadcrumbBar,
  },
  data() {
    return {
      error: null,
      isLoading: true,
      iframeSrc: null,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
    breadcrumbItems() {
      return [{ title: "PVT Prediction", nonNav: true }];
    },
    pvtOrigin() {
      return process.env.VUE_APP_PVT_PREDICTION_URL;
    },
  },
  mounted() {
    this.refreshIframeSrc();
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
  methods: {
    buildIframeUrl() {
      const token = localStorage.getItem("authToken");
      const tenantId = this.$route.path.split("/")[1];
      if (!token || !tenantId) {
        this.error = "Authentication required";
        this.$router.push("/login");
        return null;
      }

      const darkMode = this.isDarkMode ? "true" : "false";
      return `${this.pvtOrigin}?token=${token}&tenantId=${tenantId}&darkMode=${darkMode}`;
    },
    refreshIframeSrc() {
      const url = this.buildIframeUrl();
      if (url) {
        this.iframeSrc = url;
      }
    },
    syncIframeDarkMode() {
      this.$nextTick(() => {
        notifyIframeDarkMode(this.$refs.predictionIframe, this.isDarkMode, this.pvtOrigin);
      });
    },
    handleIframeLoad() {
      const iframe = this.$refs.predictionIframe;
      if (iframe) {
        this.error = null;
        window.addEventListener("message", this.handleIframeMessage);
        notifyIframeDarkMode(iframe, this.isDarkMode, this.pvtOrigin);
        setTimeout(() => {
          this.isLoading = false;
        }, 3000);
      }
    },
    handleIframeMessage(event) {
      if (event.origin === getIframeOrigin(this.pvtOrigin)) {
        const data = event.data;
        if (data && data.type === "TOKEN_EXPIRED") {
          this.handleTokenExpiration();
        }
      }
    },
    handleTokenExpiration() {
      this.$store.dispatch("tenantId/logoutUser");
      this.error = "Your session has expired. Please login again.";
    },
  },
  watch: {
    isDarkMode() {
      this.syncIframeDarkMode();
    },
  },
  beforeUnmount() {
    window.removeEventListener("message", this.handleIframeMessage);
  },
};
</script>

<style scoped>
.pvtprediction-dashboard {
  width: 100%;
  height: calc(100vh - 64px);
  position: relative;
  display: flex;
  flex-direction: column;
}

.prediction-iframe {
  width: 100%;
  flex: 1;
  min-height: 0;
  border: none;
}

.loader-container-eda {
  position: absolute;
  top: 32px;
  left: 0;
  width: 100%;
  height: calc(100% - 32px);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  z-index: 10;
}

.loader {
  text-align: center;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 4px solid #145B80;
  border-top: 4px solid #f8f9fa;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin: 0 auto 16px;
}

.dark-mode .spinner {
  border-color: #145B80;
  border-top: 4px solid #1F2937 !important;
}

.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 20px;
  color: #dc3545;
  background: #f8f9fa;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
